/* eslint-disable */
"use strict";

var config, service, movements;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  movements = config.VUE_APP_MOL_S_MOVEMENTS
}

async function getModello(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${movements}/modello/${tipo}`);
  return await response.json();
}

async function getMovimento(id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${movements}/${encodeURIComponent(id)}`
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${movements}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${movements}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "MOVIMENTI",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function creaMovimentiMultipli(magazzino, parametri, movimenti) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      magazzino,
      parametri,
      movimenti,
    };
    const response = await fetch(`${service}/${movements}/multipli`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.log(error);
    // winston.error(`creaMovimentiMultipli: ${error}`);
  }
  return {};
}

async function getFilteredMovementHeaders(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${movements}/testate/filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getFilteredMovementInventarioHeaders(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(
      `${service}/${movements}/testate/inventario/filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

// non ancora usata, non è completa
async function getFilteredMovements(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${movements}/filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaMovimento(magazzino, parametri, movimento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      magazzino,
      parametri,
      movimento,
    };
    const response = await fetch(`${service}/${movements}/singolo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    // errorService.onError('creaMovimento', error);
  }
  return {};
}

async function aggiornaMovimento(movimento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${movements}/${encodeURIComponent(movimento._id)}/update`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(movimento),
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'aggiornaMovimento')
  }
}

async function cancellaMovimento(movimentoId) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${movements}/${encodeURIComponent(movimentoId)}/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'cancellaMovimento')
  }
}

async function cancellaPerRiferimento(tipo, id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${movements}/riferimento/${tipo}/${encodeURIComponent(
        id
      )}/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'cancellaMovimento')
  }
}

async function getMovimentiPerRiferimento(tipo, id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${movements}/riferimento/${tipo}/${encodeURIComponent(id)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {}
}

/* async function getInfoProdotti(id) {
  try {
    const response = await fetch(`${service}/${movements}/riferimento/infoProdotti/${encodeURIComponent(id)}`)
    return await response.json()
  } catch (error) {
    return null
  }
} */

async function getInfoProdotti(tipo, id, data) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      tipo,
      id,
      data,
    };
    const response = await fetch(
      `${service}/${movements}/riferimento/infoProdotti`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'getInfoProdotti')
  }
}

async function getMovimentiProdotto(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${movements}/prodotto`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getMovimentiProdottoFisso(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${movements}/prodotto/fixed`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getMovimentiProdottoTipoCliente(
  prodottoId,
  tipo,
  causale,
  cliente
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    prodottoId,
    tipo,
    causale,
    cliente,
  };
  try {
    const response = await fetch(`${service}/${movements}/prodotto/tipo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

export default {
  getMovimento,
  getModello,
  cicleSync,
  getRunMode,
  creaMovimento,
  aggiornaMovimento,
  creaMovimentiMultipli,
  getFilteredMovementHeaders,
  getFilteredMovementInventarioHeaders,
  getFilteredMovements,
  getMovimentiPerRiferimento,
  cancellaMovimento,
  cancellaPerRiferimento,
  getInfoProdotti,
  getMovimentiProdotto,
  getMovimentiProdottoFisso,
  getMovimentiProdottoTipoCliente,
};
